// extracted by mini-css-extract-plugin
module.exports = {"root":"price-discount_root__Jt_iE","sizelg":"price-discount_sizelg__rr3mh"};